export const storagePaths = {
    hostDocs: 'hosts/docs/',
    conversations: 'conversations',
    chatMessages: 'messages',
    profilePictures: 'profile/pictures/',
    reservationDocs: 'reservations/docs/'
}